<p-autoComplete #gridAutocomplete
                [multiple]="false"
                [suggestions]="filteredGridOrganizations"
                (completeMethod)="filterGridOrganizations($event)"
                (onSelect)="onOrganizationSelect($event.value)"
                [minLength]="1"
                [placeholder]="placeholder"
                [inputStyleClass]="inputStyleClass"
                [class]="styleClass"
                [inputId]="inputId"
                dataKey="name"
                optionLabel="name"
                [ngClass]="{ 'ng-invalid': control.invalid, 'ng-touched': control.touched }"
                appendTo="body">
</p-autoComplete>